module.exports = __webpack_public_path__ + "static/media/WorkforceFrameworkCreatorDemo.9a087283.mp4";